import { config } from '../config';
import defaultStockIcon from '../assets/images/ebi_proyect.jpg';

const DEFAULT_S3_BASE = 'https://obitacora.s3.us-east-1.amazonaws.com/';

function s3StockUrl(fileName) {
    const base = (config.s3?.baseUrl || DEFAULT_S3_BASE).replace(/\/?$/, '/');
    return `${base}stock/${fileName}`;
}

/** Imagen por defecto cuando la acción no tiene logo propio */
export const DEFAULT_STOCK_ICON_URL = defaultStockIcon;

export function buildDefaultStockIconUrl() {
    return DEFAULT_STOCK_ICON_URL;
}

export function buildStockIconUrlFromSymbol(symbol) {
    const s = String(symbol || '').trim().toUpperCase();
    if (!s) {
        return '';
    }
    return s3StockUrl(`${s}_ico.png`);
}

export function buildStockLogoUrlFromSymbol(symbol) {
    const s = String(symbol || '').trim().toUpperCase();
    if (!s) {
        return '';
    }
    return s3StockUrl(`${s}_logo.svg`);
}

function isUsableUrl(value) {
    const url = String(value || '').trim();
    return url.length > 0 && url !== 'null' && url !== 'undefined';
}

/**
 * Resuelve URL de logo/icono de acción desde la respuesta del API (S3 stock/).
 * Prioriza logo en S3; respaldo icono y patrón SYMBOL_ico.png.
 */
export function resolveStockLogoUrl(item) {
    if (!item || typeof item !== 'object') {
        return '';
    }
    const logo = String(item.logo_url || '').trim();
    if (isUsableUrl(logo) && !logo.includes('polygon.io')) {
        return logo;
    }
    const icon = String(item.icon_url || '').trim();
    if (isUsableUrl(icon) && !icon.includes('polygon.io')) {
        return icon;
    }
    return buildStockLogoUrlFromSymbol(item.symbol) || buildStockIconUrlFromSymbol(item.symbol);
}

export function resolveStockIconUrl(item) {
    if (!item || typeof item !== 'object') {
        return '';
    }
    const icon = String(item.icon_url || '').trim();
    if (isUsableUrl(icon) && !icon.includes('polygon.io')) {
        return icon;
    }
    const logo = String(item.logo_url || '').trim();
    if (isUsableUrl(logo) && !logo.includes('polygon.io')) {
        return logo;
    }
    return buildStockIconUrlFromSymbol(item.symbol);
}
